import * as React from 'react'
import Box from '@mui/material/Box'

import Modal from '@mui/material/Modal'

const style = {
  position: 'absolute',
  top: { sm: '50%', xs: '50%' },
  left: { sm: '50%', xs: '50%' },
  width: {
    xs: '80%', // full width on mobile
    sm: '90%',
    md: '600px', // fixed width on desktop
  },
  transform: {
    xs: 'translate(-50%, -50%)',
    sm: 'translate(-50%, -50%)',
  },
  boxShadow: 24,
  maxHeight: {
    xs: '80vh',
    sm: '80vh',
  },
  // bgcolor: 'background.paper',
  borderRadius: {
    xs: '20px 20px 0 0', // bottom sheet style on mobile
    sm: '20px',
  },
}

const AppModal = ({ open, handleClose, children }) => {
  return (
    <div>
      <Modal
        className="w-full"
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="w-[100%] ">{children}</div>
        </Box>
      </Modal>
    </div>
  )
}

export default AppModal
